import {createSlice} from "@reduxjs/toolkit";

const slice = createSlice({
        name: "BOM__BOMDownloadPopup",
        initialState: {
            selected_fields: {},
            save_preference: false,
            export_type: '',
            /*
            Example Data which can be alive by reducers
            selected_fields: {
                column1: {
                    fileColumnName: 'Manufacturer Partnumber or Avnet Partnumber',
                    bomColumnName: 'manufacturer_part_number',
                    columnName: 'column1'
                },
                column2: {
                    fileColumnName: 'Customer partnumber',
                    bomColumnName: 'supplier_part_number',
                    columnName: 'column2'
                },
                column3: {
                    fileColumnName: 'Manufacturer name',
                    bomColumnName: 'manufacturer',
                    columnName: 'column3'
                }
            },
            export_type: 'xlsx'
             */
        },
        reducers: {
            load_all_selected_fields: {
                reducer: (state, action) => {
                    state.selected_fields = action.payload.selected_fields;
                },
            },
            load_initialState: {
                reducer: (state, action) => {
                    state = action.payload;
                    if (action.payload.selected_fields === undefined) {
                        state.selected_fields = {};
                    }
                    if (action.payload.export_type === undefined) {
                        state.export_type = '';
                    }
                    if (action.payload.save_preference === undefined) {
                        state.save_preference = '';
                    }
                    state.save_preference = false;
                    return state;
                },
            },
            export_type: {
                reducer: (state, action) => {
                    state.export_type = action.payload.export_type;
                },
            },
            save_preference: {
                reducer: (state, action) => {
                    if (state.save_preference) {
                        state.save_preference = '';
                    } else {
                        state.save_preference = action.payload.save_preference;
                    }
                },
            },
            remove_all_selected_fields: {
                reducer: (state, action) => {
                    state.selected_fields = {};
                },
            },
            toggle_single_selected_fields: {
                reducer: (state, action) => {
                    if (state.selected_fields[action.payload.columnName] !== undefined) {
                        delete state.selected_fields[action.payload.columnName];
                    } else {
                        if (state.selected_fields[action.payload.columnName] === undefined) {
                            state.selected_fields[action.payload.columnName] = action.payload;
                        }
                    }
                },
            },
        }
    })
;

export let {
    export_type,
    save_preference,
    load_all_selected_fields,
    remove_all_selected_fields,
    toggle_single_selected_fields,
    load_initialState
} = slice.actions;

export default slice.reducer;
